import { Skeleton } from '@ordo/ui/skeleton'
import { useEffect } from 'react'
import { Navigate } from 'react-router'
import { useAuthStore } from 'stores/auth'

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const user = useAuthStore((s) => s.user)
  const loading = useAuthStore((s) => s.loading)
  const lastFetchedAt = useAuthStore((s) => s.lastFetchedAt)
  const fetchUser = useAuthStore((s) => s.fetchUser)

  useEffect(() => {
    fetchUser()
  }, [fetchUser])

  // Initial load with no persisted user — haven't fetched yet. A returning
  // visitor has `user` rehydrated from localStorage and skips straight to
  // rendering the app (optimistic render) while fetchUser revalidates the
  // session in the background; a 401 clears the user and redirects below.
  if (lastFetchedAt < 0 && !user) {
    return (
      <div className="flex flex-1 items-center justify-center">
        <Skeleton className="h-8 w-48" />
      </div>
    )
  }

  // No user after fetch completed
  if (!user && !loading) {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}
